import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Image,
  Box,
  Flex,
  Text,
  Divider
} from "@chakra-ui/react";
import axios from "axios";
import { ReactSession } from "react-client-session";

import MainStyles from "./DashboardStyles/pricingStyles.module.css";
import success from "../../resources/images/dashboard/success.gif";
import { BeatLoader } from "react-spinners";
import { FaCheck, FaTimes } from "react-icons/fa";

const PRODUCTS = ["Rabbitstream", "Yellowstone gRPC", "Solana RPCs"];
const HEAR_ABOUT_US = [
  "Twitter / X",
  "Word of mouth",
  "Discord",
  "AI Chat",
  "Search engine",
];

const ProductInterestComponent = ({showSurveyForm,setShowSurveyForm}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [showSuccess, setShowSuccess] = useState(true);
  const [answers, setAnswers] = useState({ q1: "", q2: "" });
  const [feedbackSubmitLoading, setFeedbackSubmitLoading] =
    useState("unloaded");

  useEffect(() => {
    setShowSuccess(true);
    setAnswers({ q1: "", q2: "" });
    const timer = setTimeout(() => setShowSuccess(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const submitSurvey = async () => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      let rqUrl = `${endPoint}dashboard/product_interests`;
      setFeedbackSubmitLoading("loading");
      axios({
        
        url: rqUrl,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        data: {
          products: [answers.q1],
          heard_about_us: [answers.q2],
        },
      })
        // Handle the response from backend here
        .then((res) => {
          
          if (res.data.success === true) {
            setFeedbackSubmitLoading("success");
            setTimeout(() => setShowSurveyForm(false), 1000);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setFeedbackSubmitLoading("failed");
          setTimeout(() => setShowSurveyForm(false), 1000);
        });
    } else {
      
      setShowSurveyForm(false);
    } 
  };

  return (
    <>
      <Modal isOpen={showSurveyForm} onClose={onClose} isCentered size="sm">
        <ModalOverlay backdropFilter="blur(4px)" />
        <ModalContent bg="#111" border="1px solid #f8f8f8" borderRadius="16px">
    
          <ModalBody>
            {showSuccess ? (
              <Box as="div" pt={4} pb={6}>
                <Box as="div">
                  <Image
                    className="img-fluid"
                    src={success}
                    alt="Success Popup"
                    margin={"0 auto"}
                  />
                </Box>
                <Box
                  as="div"
                  textAlign={"center"}
                  fontFamily={"heading"}
                  fontSize="lg"
                  color="brand.white"
                >
                  Success
                </Box>
              </Box>
            ) : (
              <Box pt={4} pb={6}>
                <Box as={"div"} textAlign={"center"} fontSize={{base: "24px", md: "32px"}}> 
                  🎉
                </Box>
                <Box
                  as={"div"}
                  fontFamily={"heading"} 
                  fontWeight={"600"}
                  fontSize={{base: "md", md: "2xl"}}
                  color="brand.white"
                  textAlign={"center"}
                  pt={2}
                >
                  You’re all set!
                </Box>
                <Box
                  as={"div"}
                  fontFamily={"body"}
                  fontSize={{base: "10px", md: "14px"}}
                  color="brand.midGrey"
                  textAlign={"center"}
                  pb={2}
                >
                  Your plan’s features are officially unlocked. A quick survey for our team:
                </Box>
                <Divider borderColor={"brand.lightGrey"} my={2}/>
                <Box pt={6}>
                  <Text as={"div"} fontFamily="body" fontSize="10px" color={"brand.yellow"} me={2} textTransform={"uppercase"} textAlign={"center"} letterSpacing={"1px"} opacity={0.8}>Question 01</Text>
                  <Box
                    fontFamily={"heading"}
                    fontSize={{base: "sm", md: "md"}}
                    color={"brand.white"}
                    mb={4}
                    textAlign={"center"}
                    mt={1}
                  >
                    How did you hear about us?
                  </Box>
                  <Flex justifyContent={"center"} flexWrap={"wrap"} gap={2}>
                    {HEAR_ABOUT_US.map((option) => (
                      <Box
                        key={option}
                        as="button"
                        onClick={() => setAnswers((prev) => ({ ...prev, q2: option }))}
                        px={4}
                        py={1}
                        border="1px solid"
                        borderColor={answers.q2 === option ? "brand.red" : "brand.disableGrey"}
                        borderRadius="full"
                        bg={answers.q2 === option ? "brand.red" : "transparent"}
                        color={"brand.white"}
                        fontFamily={"body"}
                        fontSize={"12px"}
                        fontWeight={answers.q2 === option ? "600" : "500"}
                        cursor="pointer"
                        transition="all 0.15s ease"
                        _hover={{ borderColor: "brand.white" }}
                      >
                        {option}
                      </Box>
                    ))}
                  </Flex>
                </Box>
                <Box pt={8} pb={8}>
                  <Text as={"div"} fontFamily="body" fontSize="10px" color={"brand.yellow"} me={2} textTransform={"uppercase"} textAlign={"center"} letterSpacing={"1px"} opacity={0.8}>Question 02</Text>
                  <Box
                    fontFamily={"heading"}
                    fontSize={{base: "sm", md: "md"}}
                    color={"brand.white"}
                    mb={4}
                    textAlign={"center"}
                    mt={1}
                  >
                    Which product originally caught your eye?
                  </Box>
                  <Flex justifyContent={"center"} flexWrap={"wrap"} gap={2}>
                    {PRODUCTS.map((product) => (
                      <Box
                        key={product}
                        as="button"
                        onClick={() => setAnswers((prev) => ({ ...prev, q1: product }))}
                        px={4}
                        py={1}
                        border="1px solid"
                        borderColor={answers.q1 === product ? "brand.red" : "brand.disableGrey"}
                        borderRadius="full"
                        bg={answers.q1 === product ? "brand.red" : "transparent"}
                        color={"brand.white"}
                        fontFamily={"body"}
                        fontSize={"12px"}
                        fontWeight={answers.q1 === product ? "600" : "500"}
                        cursor="pointer"
                        transition="all 0.15s ease"
                        _hover={{ borderColor: "brand.white" }}
                      >
                        {product}
                      </Box>
                    ))}
                  </Flex>
                </Box>
                {feedbackSubmitLoading === "unloaded" && <Flex width={"100%"} justifyContent={"center"}>
                  <Button
                    mr={3}
                    onClick={() => submitSurvey()}
                    color={"brand.black"}
                    bg={"brand.white"}
                    border={"1px solid"}
                    borderColor={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                    fontWeight={"500"}
                    isDisabled={answers.q1 === "" || answers.q2 === ""}
                  >
                    Submit
                  </Button>
                  <Button
                    color={"brand.black"}
                    bg={"brand.white"}
                    border={"1px solid"}
                    borderColor={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                    fontWeight={"500"}
                    onClick={() => setShowSurveyForm(false)}
                  >
                    Close
                  </Button>
                </Flex>}
                {feedbackSubmitLoading === "loading" && <Box textAlign={"center"}>
                  <BeatLoader color="#F4F4F4" />
                </Box>}
                {feedbackSubmitLoading === "success" && <Flex justifyContent={"center"}>
                  <FaCheck size={"24"} color="#FBB901" />
                </Flex>}
                {feedbackSubmitLoading === "failed" && <Flex justifyContent={"center"}>
                  <FaTimes size={"28"} color="#E33535" margin={"0 auto"} />
                </Flex>}
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ProductInterestComponent;
